import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import { compose } from 'redux';
import Utils from '../common/utils';

const locationHelper = locationHelperBuilder({});

const userIsAuthenticatedRedir = connectedRouterRedirect({
	authenticatedSelector: (state: any) => state.auth.currentUser.isAuthenticated === true,
	wrapperDisplayName: 'UserIsAuthenticated',
	redirectPath: '/fourohone'
});
const userHasRoleRedir = (component: any, roles: string[]) => { 
	let config = {
		authenticatedSelector: (state: any) => Utils.isAuthorized(state.auth.currentUser.role, roles),
		redirectPath: '/fourohthree',
		wrapperDisplayName: 'UserHasRole',
		allowRedirectBack: false
	};

	return connectedRouterRedirect(config)(component);
};
export const ensureUserHasRole = compose(userIsAuthenticatedRedir, userHasRoleRedir);

const userIsAuthenticatedRedirAdminSite = connectedRouterRedirect({
	authenticatedSelector: (state: any) => state.auth.currentUser.isAuthenticated === true,
	wrapperDisplayName: 'UserIsAuthenticated',
	redirectPath: '/admin/fourohone'
});
const userHasRoleRedirAdminSite = (component: any, roles: string[]) => { 
	let config = {
		authenticatedSelector: (state: any) => Utils.isAuthorized(state.auth.currentUser.role, roles),
		redirectPath: '/admin/fourohthree',
		wrapperDisplayName: 'UserHasRole',
		allowRedirectBack: false
	};

	return connectedRouterRedirect(config)(component);
};
export const ensureUserHasRoleAdminSite = compose(userIsAuthenticatedRedirAdminSite, userHasRoleRedirAdminSite);

export const userIsNotAuthenticatedRedir = connectedRouterRedirect({	
	// Want to redirect the user when they are done loading and authenticated
	authenticatedSelector: (state: any) => state.auth.currentUser.isAuthenticated !== true,
	wrapperDisplayName: 'UserIsNotAuthenticated',
	redirectPath: (state, ownProps) => {
		return locationHelper.getRedirectQueryParam(ownProps) || '/';
	},
	allowRedirectBack: false
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/auth/authComponents.ts